import React from 'react';
import SubscriptionAppBar from '../../components/SubscriptionAppBar';
import PurchaseSubscriptionPaymentBody from '../../../PurchaseSubscription/PurchaseSubscriptionPayment/PurchaseSubscriptionPaymentBody';
import { supplementsManagement as events } from '../../../../lib/analytics/events';
import styles from '../../Collar/SubscriptionSplash/components/UpdatePayment/UpdatePayment.module.scss';

interface AddPaymentProps {
  onBack?: () => void;
  onSubmit?: () => void;
}

export default function AddPayment({ onBack, onSubmit }: AddPaymentProps) {
  const pageName = 'Add Payment';
  events.pageLoad({}, pageName);

  return (
    <>
      <SubscriptionAppBar
        title="Add Billing Info"
        forceBackButtonBehavior={onBack}
        backButtonAnalyticsEvent={() => events.goBackFromPage({}, pageName)}
        closeButtonAnalyticsEvent={() => events.closePage({}, pageName)}
      />
      <div className={styles.billingInfo}>
        <PurchaseSubscriptionPaymentBody includeCancel={false} onSubmit={onSubmit} />
      </div>
    </>
  );
}
